import ServerAddress from "../utils/ServerAddress";

const uploadMultipart = async (url, token, formData) => {
  const response = await fetch(url, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: formData,
  });

  if (!response.ok) {
    const text = await response.text();
    throw new Error(text || "Upload failed");
  }

  return response.json();
};

const uploadApi = {
  // ===================== UPLOAD =====================

  async uploadGeneric(entityType, entityId, module, fileData, token) {  
    const url = `${ServerAddress}/api/r2/upload?entityType=${entityType}&entityId=${entityId}&module=${module}`;
    return uploadMultipart(url, token, fileData);
  },

  async uploadWorkflow(workflowId, module, fileData, token) {  
    const url = `${ServerAddress}/api/r2/upload/workflow/${workflowId}?module=${module}`;
    return uploadMultipart(url, token, fileData);
  },

  async uploadTask(taskId, module, fileData, token) {
    const url = `${ServerAddress}/api/r2/upload/task/${taskId}?module=${module}`;
    return uploadMultipart(url, token, fileData);
  },
 async uploadAccount(accountId,module, fileData, token) {
    const url = `${ServerAddress}/api/r2/upload/account/${accountId}?module=${module}`;
    return uploadMultipart(url, token, fileData);
  },
  // ===================== LISTING =====================
  async listFiles(entityType, entityId, module, token) {      
    const apiRequest = (await import("./apiRequest")).default;
    const url = `/api/r2/list/${entityType}/${entityId}/${module}`;
    return apiRequest(url, "GET", token);
  },

  async listWorkflowFiles(workflowId, module, token) {  
    const apiRequest = (await import("./apiRequest")).default;
    const url = `/api/r2/list/workflow/${workflowId}/${module}`;
    return apiRequest(url, "GET", token);
  },
  async listTasksFiles(taskId, module, token) {  
    const apiRequest = (await import("./apiRequest")).default;
    const url = `/api/r2/list/task/${taskId}/${module}`;
    return apiRequest(url, "GET", token);
  },
  async listAccountFiles(accountId, module, token) {  
    const apiRequest = (await import("./apiRequest")).default;
    const url = `/api/r2/list/account/${accountId}/${module}`;
    return apiRequest(url, "GET", token);
  },

  // ===================== DOWNLOAD =====================

  async getPresignedUrl(entityType, entityId, module, fileName, token) { 
    const apiRequest = (await import("./apiRequest")).default;
    const url = `/api/r2/presigned-url/${entityType}/${entityId}/${module}/${fileName}`;
    return apiRequest(url, "GET", token);
  },

  async downloadFile(entityType, entityId, module, fileName, token) {
    const apiRequest = (await import("./apiRequest")).default;
    const url = `/api/r2/download/${entityType}/${entityId}/${module}/${fileName}`;
    return apiRequest(url, "GET", token);
  },

  // ===================== DELETE =====================

  async deleteFile(entityType, entityId, module, fileName, token) { 
    const apiRequest = (await import("./apiRequest")).default;
    const url = `/api/r2/${entityType}/${entityId}/${module}/${fileName}`;
    return apiRequest(url, "DELETE", token);
  },

  async bulkDelete(entityType, entityId, module, token) { 
    const apiRequest = (await import("./apiRequest")).default;
    const url = `/api/r2/cleanup/${entityType}/${entityId}/${module}`;
    return apiRequest(url, "DELETE", token);
  },
};

export default uploadApi;
